import { render } from "./PreGamePane.vue?vue&type=template&id=1145e488"
import script from "./PreGamePane.vue?vue&type=script&lang=js"
export * from "./PreGamePane.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__